import { Component, inject } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

import { ToastService } from '../../../services/common/toast.service';

@Component({
  selector: 'app-toast',
  imports: [NgbToastModule],
  templateUrl: './toast.html',
  styles: `
    :host {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 1.5rem 1rem;
      z-index: 1200;
      pointer-events: none;
    }
  `,
})
export class Toast {
  toastService = inject(ToastService);
}
